import { render, staticRenderFns } from "./ContactNew.vue?vue&type=template&id=3bd212e9"
import script from "./ContactNew.vue?vue&type=script&lang=js"
export * from "./ContactNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd212e9')) {
      api.createRecord('3bd212e9', component.options)
    } else {
      api.reload('3bd212e9', component.options)
    }
    module.hot.accept("./ContactNew.vue?vue&type=template&id=3bd212e9", function () {
      api.rerender('3bd212e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactNew.vue"
export default component.exports